import React, { useEffect } from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import { Wrapper } from './BackgroundVideo.style';

const videoTransition = {
    initial: { opacity: 1 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};

interface Props {
    step: number;
    videoSources: {
        [key: number]: {
            mp4: string;
            webm: string;
            duration: number;
        };
    };
}

export function BackgroundVideo({ step, videoSources }: Props) {
    useEffect(() => {
        Object.values(videoSources).forEach((sources) => {
            Object.values(sources).forEach((src) => {
                const video = document.createElement('video');

                if (typeof src === 'string') {
                    video.src = src;
                    video.load();
                }
            });
        });
    }, [videoSources]);

    return (
        <Wrapper>
            <AnimatePresence>
                {step === 1 && (
                    <motion.video muted playsInline autoPlay loop preload="auto" key={`video-1`} {...videoTransition}>
                        <source src={videoSources[1].mp4} />
                        <source src={videoSources[1].webm} />
                    </motion.video>
                )}
                {step === 2 && (
                    <motion.video muted playsInline autoPlay loop preload="auto" key={`video-2`} {...videoTransition}>
                        <source src={videoSources[2].mp4} />
                        <source src={videoSources[2].webm} />
                    </motion.video>
                )}
                {step === 3 && (
                    <motion.video muted playsInline autoPlay loop preload="auto" key={`video-3`} {...videoTransition}>
                        <source src={videoSources[3].mp4} />
                        <source src={videoSources[3].webm} />
                    </motion.video>
                )}
            </AnimatePresence>
        </Wrapper>
    );
}
